import { render, staticRenderFns } from "./GameList.vue?vue&type=template&id=a613914c&scoped=true&"
import script from "./GameList.vue?vue&type=script&lang=js&"
export * from "./GameList.vue?vue&type=script&lang=js&"
import style0 from "./GameList.vue?vue&type=style&index=0&id=a613914c&scoped=true&lang=css&"
import style1 from "./GameList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a613914c",
  null
  
)

export default component.exports